import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
export function useElementDimensions(elementRef) {
  var _elementRef$current3, _elementRef$current4;
  var _useState = useState({
      height: 0,
      width: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    dimensions = _useState2[0],
    setDimensions = _useState2[1];
  useEffect(function () {
    var getDimensions = function getDimensions() {
      var _elementRef$current, _elementRef$current2;
      setDimensions({
        height: (elementRef == null ? void 0 : (_elementRef$current = elementRef.current) == null ? void 0 : _elementRef$current.offsetHeight) || 0,
        width: (elementRef == null ? void 0 : (_elementRef$current2 = elementRef.current) == null ? void 0 : _elementRef$current2.offsetWidth) || 0
      });
    };
    if (elementRef != null && elementRef.current) {
      getDimensions();
    }
    window.addEventListener('resize', getDimensions);
    return function () {
      window.removeEventListener('resize', getDimensions);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementRef == null ? void 0 : (_elementRef$current3 = elementRef.current) == null ? void 0 : _elementRef$current3.offsetHeight, elementRef == null ? void 0 : (_elementRef$current4 = elementRef.current) == null ? void 0 : _elementRef$current4.offsetWidth]);
  return dimensions;
}